import { useState } from 'react';
import { addDoc, arrayUnion, collection, deleteDoc, doc, serverTimestamp, updateDoc } from '../fs';
import { db } from '../firebase';
import { CLINICAS, nombreClinica } from '../clinicas';
import { diaHora, hoyISO, tel, useColeccion } from './comun';
import { validarTelefono } from '../validar.js';

// Llamadas y recados: quién llamó, para qué, para quién, y si ya se ha devuelto
// "hace 20 min", "hace 3 h", "ayer 18:30"
export function hace(iso) {
  const m = (Date.now() - new Date(iso).getTime()) / 6e4;
  if (m < 1) return 'ahora';
  if (m < 60) return `hace ${Math.round(m)} min`;
  if (m < 12 * 60) return `hace ${Math.round(m / 60)} h`;
  return diaHora(iso);
}

export function Llamadas({ clinicas, yo, uid }) {
  const pend = useColeccion('llamadas', clinicas, [['hecha', '==', false]]);
  const hechasHoy = useColeccion('llamadas', clinicas, [['hecha', '==', true], ['hechaDia', '==', hoyISO()]]);
  const vacio = { quien: '', telefono: '', motivo: '', para: '' };
  const [f, setF] = useState({ clinica: clinicas[0], ...vacio });
  const [abierto, setAbierto] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const vt = validarTelefono(f.telefono); // AUD-DIA-10
  const guardar = async (e) => {
    e.preventDefault(); if ((!f.motivo.trim() && !f.quien.trim()) || !vt.ok) return;
    await addDoc(collection(db, 'llamadas'), { ...f, quien: f.quien.trim().slice(0, 80), motivo: f.motivo.trim().slice(0, 300), para: f.para.trim().slice(0, 60), telefono: vt.valor, clinica: clinicas.includes(f.clinica) ? f.clinica : clinicas[0], hecha: false, por: yo, porUid: uid, creado: new Date().toISOString(), ts: serverTimestamp() });
    setF({ ...f, ...vacio }); setAbierto(false);
  };
  const hecha = (l) => updateDoc(doc(db, 'llamadas', l.id), { hecha: true, hechaPor: yo, hechaEn: new Date().toISOString(), hechaDia: hoyISO() });

  return (
    <>
      <form className={`apunte ${abierto ? 'abierto' : ''}`} onSubmit={guardar}>
        <input className="campo" placeholder="Apuntar una llamada: ¿quién ha llamado?" maxLength={80} value={f.quien} onChange={set('quien')} onFocus={() => setAbierto(true)} />
        {abierto && <>
          <input className="campo" placeholder="Teléfono (para poder llamar o escribir)" value={f.telefono} onChange={set('telefono')} inputMode="tel" type="tel" maxLength={20} aria-invalid={!vt.ok} />
          {!vt.ok && <small className="error" role="alert">{vt.error}</small>}
          <input className="campo ancho" placeholder="Qué quiere" maxLength={300} value={f.motivo} onChange={set('motivo')} />
          <input className="campo" placeholder="Para quién" maxLength={60} value={f.para} onChange={set('para')} />
          {clinicas.length > 1 && <select className="campo" value={f.clinica} onChange={set('clinica')}>{CLINICAS.filter((c) => clinicas.includes(c.id)).map((c) => <option key={c.id} value={c.id}>{c.nombre}</option>)}</select>}
          <div className="apunte-acc">
            <button type="button" className="btn sec" onClick={() => { setF({ ...f, ...vacio }); setAbierto(false); }}>Cancelar</button>
            <button className="btn" disabled={(!f.quien.trim() && !f.motivo.trim()) || !vt.ok}>Apuntar</button>
          </div>
        </>}
      </form>
      <div className="lista">
        {!pend ? <p className="lista-vacia">Cargando…</p> : !pend.length ? <p className="lista-vacia">No hay llamadas pendientes.</p> : (
          pend.sort((a, b) => a.creado.localeCompare(b.creado)).map((l) => {
            const horas = (Date.now() - new Date(l.creado).getTime()) / 36e5;
            return (
              <div key={l.id} className={`fila ${horas > 4 ? 'urge' : ''}`}>
                <div className="fila-cuerpo">
                  <div className="fila-tit"><b>{l.quien || 'Sin nombre'}</b>{l.para && <span className="tenue"> → {l.para}</span>}</div>
                  {l.motivo && <div>{l.motivo}</div>}
                  <div className="fila-meta"><span className={horas > 4 ? 'tarde' : ''}>{hace(l.creado)}</span>{[l.por?.split(' ')[0], clinicas.length > 1 && nombreClinica(l.clinica)].filter(Boolean).map((x) => ` · ${x}`).join('')}</div>
                </div>
                <div className="fila-acc">
                  {l.telefono ? <a className="btn sec mini" href={`tel:${l.telefono}`}>Llamar</a> : <span className="tenue" style={{ fontSize: '.75rem' }}>Sin teléfono</span>}
                  {l.telefono && <a className="btn sec mini" href={`https://wa.me/${tel(l.telefono)}`} target="_blank" rel="noreferrer">WhatsApp</a>}
                  <button className="btn mini" onClick={() => hecha(l)}>Hecha</button>
                  <button className="hosp-x" title="Borrar" onClick={() => window.confirm('¿Borrar?') && deleteDoc(doc(db, 'llamadas', l.id))}>✕</button>
                </div>
              </div>
            );
          })
        )}
      </div>
      {hechasHoy?.length > 0 && (
        <details className="prev-detalle"><summary>Hechas hoy ({hechasHoy.length})</summary>
          <div className="lista">
            {hechasHoy.map((l) => <div key={l.id} className="fila hecha"><div className="fila-cuerpo">{l.quien} · {l.motivo}<div className="fila-meta">{l.hechaPor?.split(' ')[0]} a las {new Date(l.hechaEn).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}</div></div>
              <div className="fila-acc"><button className="btn sec mini" onClick={() => updateDoc(doc(db, 'llamadas', l.id), { hecha: false })}>Deshacer</button></div></div>)}
          </div>
        </details>
      )}
    </>
  );
}

// Notas de turno: avisos para el siguiente que entre
export function Notas({ clinicas, yo, uid }) {
  const desde = hoyISO(new Date(Date.now() - 7 * 864e5));
  const notas = useColeccion('notasTurno', clinicas, [['dia', '>=', desde]]);
  const [f, setF] = useState({ clinica: clinicas[0], texto: '', importante: false });
  const guardar = async (e) => {
    e.preventDefault(); if (!f.texto.trim()) return;
    await addDoc(collection(db, 'notasTurno'), { ...f, texto: f.texto.trim().slice(0, 1000), por: yo, porUid: uid, creado: new Date().toISOString(), dia: hoyISO(), vistoPor: [uid], hecha: false }); // AUD-DIA-09
    setF({ ...f, texto: '', importante: false });
  };
  const lista = (notas || []).filter((n) => !n.hecha || n.dia === hoyISO()).sort((a, b) => Number(!!b.importante && !b.hecha) - Number(!!a.importante && !a.hecha) || b.creado.localeCompare(a.creado));
  return (
    <>
      <form className={`apunte ${f.texto ? 'abierto' : ''}`} onSubmit={guardar}>
        <input className="campo ancho" placeholder="Aviso para el siguiente turno…" maxLength={1000} value={f.texto} onChange={(e) => setF({ ...f, texto: e.target.value })} />
        {f.texto && <>
          {clinicas.length > 1 && <select className="campo" value={f.clinica} onChange={(e) => setF({ ...f, clinica: e.target.value })}>{CLINICAS.filter((c) => clinicas.includes(c.id)).map((c) => <option key={c.id} value={c.id}>{c.nombre}</option>)}</select>}
          <label className="apunte-check"><input type="checkbox" checked={f.importante} onChange={(e) => setF({ ...f, importante: e.target.checked })} /> Importante</label>
          <div className="apunte-acc"><button className="btn">Dejar nota</button></div>
        </>}
      </form>
      <div className="lista">
        {!lista.length ? <p className="lista-vacia">Sin notas esta semana.</p> : lista.map((n) => {
          const nueva = !(n.vistoPor || []).includes(uid);
          return (
            <div key={n.id} className={`fila ${n.importante && !n.hecha ? 'urge' : ''} ${n.hecha ? 'hecha' : ''} ${nueva ? 'nueva' : ''}`}>
              <div className="fila-cuerpo">
                <div style={{ textDecoration: n.hecha ? 'line-through' : undefined }}>{n.importante && !n.hecha && <b className="tarde">Importante · </b>}{n.texto}</div>
                <div className="fila-meta">{nueva && <b className="nuevo">Nueva · </b>}{n.por?.split(' ')[0]} · {diaHora(n.creado)}{clinicas.length > 1 ? ` · ${nombreClinica(n.clinica)}` : ''}{n.hecha ? ` · resuelta por ${n.hechaPor?.split(' ')[0]}` : ''}</div>
              </div>
              <div className="fila-acc">
                {nueva && <button className="btn sec mini" onClick={() => updateDoc(doc(db, 'notasTurno', n.id), { vistoPor: arrayUnion(uid) })}>Visto</button>}
                {!n.hecha && <button className="btn sec mini" onClick={() => updateDoc(doc(db, 'notasTurno', n.id), { hecha: true, hechaPor: yo, vistoPor: arrayUnion(uid) })}>Resuelto</button>}
                {n.porUid === uid && <button className="hosp-x" title="Borrar" onClick={() => window.confirm('¿Borrar la nota?') && deleteDoc(doc(db, 'notasTurno', n.id))}>✕</button>}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
